import { apiClient } from "helpers/api_helper";

export const getAllUserRolesForSelect = async (params?: URLSearchParams) => {
    try {
        const response = await apiClient.get(`/api/v1/UserRole/GetUserRoleSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllUserRoles = async (params?: URLSearchParams) => {
    try {
        const response = await apiClient.get(`/api/v1/UserRole/GetPagedList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getRolesById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/UserRole/Get?Id=${id}`);
        return response;

    } catch (error: any) {
        throw new Error(error);
    }
};

export const createRole = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/UserRole/Insert', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateRole = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/UserRole/Update', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteRole = async (id: any) => {
    try {
        const response = await apiClient.delete(`api/v1/UserRole/Delete/id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getRolePermissionById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/UserRole/GetPermissions?roleid=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const updateRolePermission = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/UserRole/UpsertPermissions', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateAllUserPermissionByRoleId = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/UserRole/UpdateAllUserPermissionsByRoleId', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

